module.exports = __webpack_public_path__ + "img/icon-evening.b52b7c15.svg";